import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDock = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15,
	height: 14,
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M4.5 5.5V5a.5.5 0 0 0-.5.5h.5Zm10 0h.5a.5.5 0 0 0-.5-.5v.5Zm0 6v.5a.5.5 0 0 0 .5-.5h-.5Zm-10 0H4a.5.5 0 0 0 .5.5v-.5ZM1 0v14h1V0H1ZM0 3h15V2H0v1Zm4.5 3h10V5h-10v1Zm9.5-.5v6h1v-6h-1Zm.5 5.5h-10v1h10v-1Zm-9.5.5v-6H4v6h1Zm1-9v3h1v-3H6Zm6 0v3h1v-3h-1Z"
	})]
});
const ForwardRef = forwardRef(SvgDock);
export { ForwardRef as ReactComponent };
